import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";
import { useTranslation } from "react-i18next";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();
  const { i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      dir={isRTL ? 'rtl' : 'ltr'}
      position={isRTL ? 'bottom-left' : 'bottom-right'}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg rtl:text-right ltr:text-left",
          title: "group-[.toast]:text-foreground group-[.toast]:font-semibold rtl:text-right ltr:text-left",
          description: "group-[.toast]:text-muted-foreground rtl:text-right ltr:text-left",
          actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground ltr:ml-auto rtl:mr-auto",
          cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground ltr:ml-auto rtl:mr-auto",
          closeButton: "group-[.toast]:bg-background/90 group-[.toast]:text-foreground/80 group-[.toast]:border group-[.toast]:border-border/50 group-[.toast]:shadow-sm group-[.toast]:hover:bg-background group-[.toast]:hover:text-foreground group-[.toast]:hover:border-border group-[.toast]:hover:shadow ltr:right-2 rtl:left-2",
          error: "group-[.toast]:bg-destructive group-[.toast]:text-destructive-foreground group-[.toast]:border-destructive",
          success: "group-[.toast]:bg-success group-[.toast]:text-success-foreground group-[.toast]:border-success",
          warning: "group-[.toast]:bg-warning group-[.toast]:text-warning-foreground group-[.toast]:border-warning",
          info: "group-[.toast]:bg-info group-[.toast]:text-info-foreground group-[.toast]:border-info",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
